export function useLocalStorageRouteCheck(localStorageKey, allowedRouteNames) {
  const route = useRoute();

  watch(route, (newRoute) => {
    // Check if the current route name is NOT included in the allowedRouteNames array
    if (!allowedRouteNames.includes(newRoute.fullPath)) {
      if (localStorage.getItem(localStorageKey)) {        
        localStorage.removeItem(localStorageKey);
        console.log(`[Composable] '${localStorageKey}' removed due to route change to '${newRoute.fullPath}'.`);
      }
    }
  });

  // Optional: Initial check if needed when the composable is used in a component
  // if (!allowedRouteNames.includes(route.name) && localStorage.getItem(localStorageKey)) {
  //   localStorage.removeItem(localStorageKey);
  //   console.log(`[Composable - Initial] '${localStorageKey}' removed on load.`);
  // }
}